import { BaseClient } from '@is24at/react-utils';
import { HTTP_HEADERS } from '@is24at/react-constants';
import { getCsrfTokenFromCookie } from '@is24at/react-utils/src/utils/getCsrfTokenFromCookie';

export const LEADS_BASE_PATH = '/leads';

class LeadsClient extends BaseClient {
  createContactRequest = (data) =>
    this.fetch(`${LEADS_BASE_PATH}/contactRequests`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        [HTTP_HEADERS.KEYS.X_CSRF_TOKEN]: getCsrfTokenFromCookie() || '',
      },
      body: JSON.stringify(data),
    });
}

export default LeadsClient;
